import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import type { Pathname } from '@components/main-components/link/AccessibleLink';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import type { ParamsValues } from '@context/params';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment } from '@graphql/reactQuery';
import { SeeAllUserInfoFragmentDoc } from '@graphql/reactQuery';
import { webappUriPath } from '@utils/url';

export const SeeAllArrow = ({
  user: userFragment,
  path,
  params,
  className,
}: {
  user: FragmentType<SeeAllUserInfoFragmentDoc>;
  path: Pathname;
  params: ParamsValues | null;
  className?: string;
}) => {
  const user = getFragment(SeeAllUserInfoFragmentDoc, userFragment);

  const href = webappUriPath(user.webappUri, {
    subpath: path,
    params,
  });

  return (
    <AccessibleLink pathnameUri={href} className={className}>
      <FontAwesomeIcon icon={faChevronRight} size="lg" className="text-black" />
    </AccessibleLink>
  );
};
